import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { OverspeedProfileResponse, OverspeedProfileCreateRequest, OverspeedProfileUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { GridColumnHelper, EnumToComboValues } from '../utils';
import { OverspeedProfileDetailsSectionHandler } from './details.section';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '../../entities';

@RegisterEntityHandler('overspeedprofile')
@Injectable()
export class OverspeedProfileHandler extends EntityHandler<OverspeedProfileResponse> {

    constructor(
        admin: AdminEditorService
    ) {
        super(admin);
    }

    states = ['active', 'deleted'];

    listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        return this.admin.getCached(`listOverspeedProfiles/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.entities.listOverspeedProfiles(ownerId, false, offset, limit, sort, filter), 3).then((response: EntityListResult) => ({
            ...response,
            type: 'overspeedprofile',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.OVERSPEEDPROFILES'),
        }));
    }

    getEntity(id: string): Promise<OverspeedProfileResponse> {
        return this.admin.getCached(`getOverspeedProfile/${id}`, api => api.entities.getOverspeedProfile(id), 10);
    }

    createEntity(ownerId: string, entity: OverspeedProfileCreateRequest): Promise<OverspeedProfileResponse> {
        entity.ownerId = ownerId;
        return this.admin.applyUpdate(api => api.entities.createOverspeedProfile(entity));
    }

    setEntityState(entity: any, state: string): Promise<any> {
        return this.admin.applyUpdate(api => api.entities.updateOverspeedProfile(entity.id, { state: state as any }));
    }

    getGridIcon(item: OverspeedProfileResponse): string {
        return item.items && item.items.length > 0 ? ICONS.overspeedprofile : 'exclamation-triangle';
    }

    getGridColumns(_ownerId: string): Promise<IKuiTableCol[]> {
        const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.OVERSPEEDPROFILE.COLUMNS');
        const columns: IKuiTableCol[] = [
            grid.IconTextColumn('name', 'NAME', this.getGridIcon),
            grid.ComboColumn('state', 'STATE', EnumToComboValues(this.admin.i18n, 'ADMIN.STATES', this.states, ['deleted']), 80),
            grid.TimeAgoColumn('modifiedDate', 'MODIFIED'),
        ];
        return Promise.resolve(columns);
    }

    getEditorSections(ownerId: string, _entity: any): Promise<SectionHandlerGroup<OverspeedProfileResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new OverspeedProfileDetailsSectionHandler(this.admin, ownerId, false),
            ].filter(x => x),
        }]);
    }

    getCreationSections(ownerId: string): Promise<{ entityType: string, entity: OverspeedProfileUpdateRequest, sections: FormSectionHandler<OverspeedProfileResponse, any>[] }> {
        return Promise.resolve({
            entityType: 'overspeedprofile',
            entity: {}, // set up some defaults if you want
            sections: [
                new OverspeedProfileDetailsSectionHandler(this.admin, ownerId, true),
            ],
        });
    }

}












